import { KeepAlive } from '@vue/runtime-core'
import { FunctionalComponent } from 'vue'
import { RouterView } from 'vue-router'

const KeepBlankLayout: FunctionalComponent = () => {
  const slot = {
    default: ({ Component }: any) => {
      if (Component) {
        return (
          <KeepAlive>
            <Component />
          </KeepAlive>
        )
      }
    },
  }

  return <RouterView v-slots={slot} />
}

export default KeepBlankLayout
